import { all } from 'redux-saga/effects'

import dettaglioCrimineSagas from './ossif/ossifDettaglioCrimineSaga'

export default function* rootSaga(getState) {
  yield all([dettaglioCrimineSagas()])
}
